import { render, staticRenderFns } from "./SummaryDairy.vue?vue&type=template&id=4f2e4485&scoped=true"
import script from "./SummaryDairy.vue?vue&type=script&lang=ts"
export * from "./SummaryDairy.vue?vue&type=script&lang=ts"
import style0 from "./SummaryDairy.vue?vue&type=style&index=0&id=4f2e4485&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e4485",
  null
  
)

export default component.exports